<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'admin.master_management' | transloco }}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <wj-menu [(value)]="readonly" [isDisabled]="masters.hasChanges()" [header]="'admin.edit_mode' | transloco">
                                <wj-menu-item [value]="true">{{ 'admin.locked' | transloco }}</wj-menu-item>
                                <wj-menu-item [value]="false">{{ 'admin.editable' | transloco }}</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div class="col-md-3"><span>{{ 'admin.n_matches' | transloco: {count: (masters.totalCount | number)} }}</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <wj-flex-grid #masterGrid [allowAddNew]="true" [allowDelete]="true" [isReadOnly]="readonly" style="height:500px" [itemsSource]="masters">
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="'admin.category' | transloco" [binding]="'category'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'admin.value' | transloco" [binding]="'value'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'admin.sort_order' | transloco" [binding]="'sort'" [dataType]="'Number'" [width]="100"></wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div style="float:left; min-width: 150px;">
                            <wj-menu [(value)]="masters.pageSize" [header]="'admin.page_size' | transloco">
                                <wj-menu-item [value]="100">100</wj-menu-item>
                                <wj-menu-item [value]="500">500</wj-menu-item>
                                <wj-menu-item [value]="1000">1000</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-navigator [cv]="masters"></wj-collection-view-navigator>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-pager [cv]="masters"></wj-collection-view-pager>
                        </div>
                    </div>
                    <div class="row">
                        <button *ngIf="!readonly" [disabled]="!masters.hasChanges()" (click)="masters.saveChanges()" class="btn btn-primary btn-block">{{ 'admin.save_changes' | transloco }}</button>
                        <button *ngIf="!readonly" [disabled]="!masters.hasChanges()" (click)="masters.cancelChanges()" class="btn btn-primary btn-block">{{ 'common.cancel' | transloco }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
